import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';
import { Building2, Shield, Users, Scale, Building, Landmark, Heart, Store, Receipt, Package, Globe, Flag } from 'lucide-react';

const iconMap = {
  commerce: Building2,
  interior: Shield,
  labor: Users,
  justice: Scale,
  municipality: Building,
  finance: Landmark,
  health: Heart,
  chamber: Store,
  tax: Receipt,
  customs: Package,
  foreign: Globe,
  embassies: Flag
};

const Clients = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const clients = [
    { id: 1, nameKey: 'commerce', icon: 'commerce' },
    { id: 2, nameKey: 'interior', icon: 'interior' },
    { id: 3, nameKey: 'labor', icon: 'labor' },
    { id: 4, nameKey: 'foreign', icon: 'foreign' },
    { id: 5, nameKey: 'justice', icon: 'justice' },
    { id: 6, nameKey: 'municipality', icon: 'municipality' },
    { id: 7, nameKey: 'finance', icon: 'finance' },
    { id: 8, nameKey: 'health', icon: 'health' },
    { id: 9, nameKey: 'chamber', icon: 'chamber' },
    { id: 10, nameKey: 'tax', icon: 'tax' },
    { id: 11, nameKey: 'customs', icon: 'customs' },
    { id: 12, nameKey: 'embassies', icon: 'embassies' }
  ];

  return (
    <section className="clients-section">
      <div className="section-header">
        <h2 className="display-large section-title">{t('clients.title')}</h2>
        <p className="body-large section-subtitle">
          {t('clients.subtitle')}
        </p>
      </div>

      <div className="clients-grid">
        {clients.map((client) => {
          const IconComponent = iconMap[client.icon];
          return (
            <div key={client.id} className="client-card">
              <div className="client-icon-wrapper">
                <IconComponent size={40} className="client-icon" />
              </div>
              <h3 className="body-large client-name">
                {t(`clients.organizations.${client.nameKey}`)}
              </h3>
            </div>
          );
        })}
      </div>

      <div className="additional-clients">
        <p className="body-medium additional-text">
          {t('clients.additional')}
        </p>
      </div>
    </section>
  );
};

export default Clients;
